import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'chameleon/ui-stack/ui/base/modal';
import './styles.scss';

const ScreenModal = (props) => {
  const {
    children,
    dialogClassName,
    wrapperClassName,
    headingClassName,
    topBarClassName,
    title,
    subTitle,
    topBar,
    onClose,
    size,
    showCloseButton,
    headerWithBorder,
    contentWithSpacing,
    contentLabel,
    isContainingBlock,
    isScrollableContent,
    hasTitleWithTooltip,
  } = props;
  const themeClassNames = {
    'full-page': {
      topBar: topBarClassName || 'min-h-28 bg-blue-100',
    },
    default: {
      topBar: null,
    },
  };
  const isFullPage = size === 'full';
  const theme = themeClassNames[isFullPage ? 'full-page' : ''] || {};

  return (
    <Modal
      size={size}
      headerWithBorder={headerWithBorder}
      group="part-of-screen-modal"
      returnFocus
      dialogClassName={dialogClassName}
      topBarClassName={theme.topBar}
      wrapperClassName={wrapperClassName}
      headingClassName={headingClassName}
      contentClassName="desktop:h-85-screen h-auto flex flex-col"
      title={title}
      subTitle={subTitle}
      topBar={topBar}
      onClose={onClose}
      isFullPage={isFullPage}
      showCloseButton={showCloseButton}
      contentWithSpacing={contentWithSpacing}
      contentLabel={contentLabel}
      isContainingBlock={isContainingBlock}
      isScrollableContent={isScrollableContent}
      hasTitleWithTooltip={hasTitleWithTooltip}
    >
      {children}
    </Modal>
  );
};

ScreenModal.props = {
  // The title of the modal
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Places content in the top bar between title and X
  topBar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // The class to style the dialog window.
  dialogClassName: PropTypes.string,
  // The class to style the modal content.
  contentClassName: PropTypes.string,
  // The class to style the modal wrapper.
  wrapperClassName: PropTypes.string,
  // The class to style the modal heading title.
  headingClassName: PropTypes.string,
  // The class to style the top bar.
  topBarClassName: PropTypes.string,
  // Handler for displaying X button.
  showCloseButton: PropTypes.bool,
  // Callback for submitting when confirmation buttons are available.
  onSuccess: PropTypes.func,
  // Callback for closing the modal and X button
  onClose: PropTypes.func,
  // If true the top bar will have borders
  headerWithBorder: PropTypes.bool,
  // If true the content receives spacing tailwind classes (margins, paddings)
  contentWithSpacing: PropTypes.bool,
  // The accessibility content label
  contentLabel: PropTypes.func,
  // Object for setting accessibility aria options
  aria: PropTypes.object,
  // Sets the size of the modal
  size: PropTypes.string,
  // Transforms the wrapper container into a Containing Block
  isContainingBlock: PropTypes.bool,
  // If true it removes the scrolls from modal body
  isScrollableContent: PropTypes.bool,
  // If true the title tooltip algorithm is used to determine
  // if title needs tooltip
  hasTitleWithTooltip: PropTypes.bool,
};

ScreenModal.defaultProps = {
  title: <div />,
  topBar: null,
  dialogClassName: null,
  contentClassName: null,
  wrapperClassName: null,
  headingClassName: null,
  topBarClassName: null,
  showCloseButton: true,
  onSuccess: () => {},
  onClose: () => {},
  headerWithBorder: false,
  contentWithSpacing: true,
  contentLabel: '',
  aria: {},
  size: 'huge',
  isContainingBlock: false,
  isScrollableContent: true,
  hasTitleWithTooltip: true,
};

export default ScreenModal;
